import axios from 'axios'

const instance = axios.create()

export default function isOnline() {

    return instance.get('https://icanhazip.com')
        .then(response => true)
        .catch(error => false)
}